export default {
  methods: {
    navigate(subUrl) {
      this.$router.push(subUrl)
    },
    openSnackbar(options) {
      options.queue = false
      this.$buefy.snackbar.open(options)
    },
    openErrorSnackbar(message) {
      this.openSnackbar({
        actionText: 'ERROR',
        message,
        type: 'is-danger',
      })
    },
    openSuccessSnackbar(message) {
      this.openSnackbar({
        message,
        actionText: 'SUCCESS'
      })
    },
    openErrorMessageBox(message) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    openMessageBox(message) {
      this.$buefy.dialog.alert(message)
    },
    openDangerConfirmMessageBox(message, confirmCallback) {
      this.$buefy.dialog.confirm({
        title: 'Warning',
        message: message,
        confirmText: 'Confirm',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => { confirmCallback() }
      })
    }
  }
}